<template>
  <div class="contain padc">
    <div class="layout-desc-check">
      <div class="content-desc-check">
        <div class="ele-addvisit"><span class="label-add-visit">线索名称</span><input v-if="!setReadOnly"
                 type="text"
                 placeholder="请输入线索名称（必填）"
                 class="text-addvisit"
                 v-model="clue.clueBase.clueName"><span v-if="setReadOnly"
                class="info-desc-check">{{this.clue.clueBase.clueName}}</span></div>

        <div class="ele-addvisit"><span class="label-add-visit">客户</span><input type="text"
                 placeholder="请输入客户中文名称"
                 class="text-addvisit"
                 v-model="clue.clueBase.customerName"></div>

        <div class="ele-addvisit"><span class="label-add-visit"
                style="width: 0.84rem">销售员</span><span v-if="setReadOnly"
                class="info-desc-check">{{this.clue.clueBase.toSalTxt}}</span><input type="text"
                 placeholder="请输入销售员姓名进行搜索"
                 class="text-addvisit"
                 v-model="clue.clueBase.toSalTxt"
                 v-show="clue.clueBase.toSal=='0'"
                 v-if="!setReadOnly"
                 @blur="searchSalData"><span style="padding-left:0.1rem"
                v-show="clue.clueBase.toSal=='0'"
                v-if="!setReadOnly"
                @click="searchSalData"><img src="../../assets/images/icon-search.png"></span>
          <span style="margin-left:3.98rem"
                v-show="clue.clueBase.toSal!='0'"
                v-if="!setReadOnly">{{clue.clueBase.toSalTxt}}</span>
          <van-button plain
                      type="info"
                      style="width:0.84rem;height:0.54rem;padding:0.1rem;font-size:0.24rem"
                      v-show="clue.clueBase.toSal!='0'"
                      v-if="!setReadOnly"
                      @click="changeSal">修改</van-button>
        </div>

        <div class="ele-addvisit"><span class="label-add-visit">跟进状态</span><input type="text"
                 placeholder="请选择跟进状态（必选）"
                 class="text-addvisit"
                 readonly
                 @click="showPopup(0,pickerSet)"
                 v-model="clue.clueBase.statusTxt"></div>

        <div class="ele-addvisit"><span class="label-add-visit">信息来源</span><input type="text"
                 placeholder="请选择信息来源（必选）"
                 class="text-addvisit"
                 readonly
                 @click="showPopup(1,pickerSet)"
                 v-model="clue.clueBase.infoSourceTxt"></div>

        <div class="ele-addvisit"><span class="label-add-visit">业务类型</span><input type="text"
                 placeholder="请输入业务类型"
                 class="text-addvisit"
                 v-model="clue.clueBase.busInfo"></div>
      </div>
    </div>

    <!--模块-->
    <div class="layout-desc-check">
      <div class="content-desc-check">
        <div class="ele-addvisit"><span class="label-add-visit">姓名</span><input v-if="!setReadOnly"
                 type="text"
                 placeholder="请输入姓名（必填）"
                 class="text-addvisit"
                 v-model="clue.clueBase.contactName"><span v-if="setReadOnly"
                class="info-desc-check">{{this.clue.clueBase.contactName}}</span></div>
        <div class="ele-addvisit"><span class="label-add-visit">职务</span><input type="text"
                 placeholder="请输入职务"
                 class="text-addvisit"
                 v-model="clue.clueBase.position"></div>
        <div class="ele-addvisit"><span class="label-add-visit">电话</span><input v-if="!setReadOnly"
                 type="text"
                 placeholder="请输入电话（必填）"
                 class="text-addvisit"
                 v-model="clue.clueBase.tel"><span v-if="setReadOnly"
                class="info-desc-check">{{this.clue.clueBase.tel}}</span></div>
        <div class="ele-addvisit"><span class="label-add-visit">微信</span><input type="text"
                 placeholder="请输入微信"
                 class="text-addvisit"
                 v-model="clue.clueBase.weChat"></div>
        <div class="ele-addvisit"><span class="label-add-visit">邮箱</span><input type="text"
                 placeholder="请输入姓邮箱"
                 class="text-addvisit"
                 v-model="clue.clueBase.mail"></div>
      </div>
    </div>
    <div class="layout-desc-check">
      <div class="tit-desc-check color-nol">线索背景及需求详情</div>
      <textarea class="textarea-addvisit"
                placeholder="请输入记录"
                v-model="clue.clueBackGround"
                @click="showheigh()"></textarea>
    </div>

    <div v-if="clue.clueHistoryLog.length>0"
         class="layout-desc-check"
         style="padding-bottom:1.44rem">
      <div class="tit-desc-check color-nol">历史记录</div>
      <div class="node-desc-check"
           style="overflow-y: scroll;max-height:5.54rem">
        <div class="content-desc-check cotent-contact-check"
             v-for="row in clue.clueHistoryLog"
             :key="row.autoId">
          <div class="ele-addvisit"
               style="height:100%">
            <div style="margin-top:0.3rem;margin-bottom:0.3rem">{{row.infoBackground}}</div>
          </div>
          <div class="ele-addvisit">{{row.createByTxt+' '+row.createTimeTxt}}</div>
        </div>
      </div>
    </div>

    <!--模块-->
    <div v-show="submitShow"
         class="content-btn-check">
      <button class="chancel-desc-check widthmax"
              @click="cancel">取消</button>
      <button class="sure-desc-check widthmax"
              @click="submit">提交</button>
    </div>
    <van-popup v-model="pop.show"
               round
               :position="pop.location"
               :style="{ height: pop.popHeight }">
      <van-picker v-show="pop.showCom==pickerSet"
                  :title="pop.title"
                  show-toolbar
                  :columns="pop.list"
                  :confirm-button-text="pop.confirmTxt"
                  :cancel-button-text="pop.cancelTxt"
                  @confirm="onPopConfirm"
                  @cancel="hidePopup"></van-picker>
    </van-popup>

  </div>
</template>
<script>
import clueModel from '../../api/model/clue'
import globParamModel from '../../api/model/glob-param'
import commonModel from '../../api/model/common'
import smsModel from '../../api/model/sms'
import { mapState } from 'vuex'
export default {
  name: 'ClueDetail',
  props: ['id'],
  data() {
    return {
      //系统参数
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      submitShow: true, //提交按钮显示
      pickerSet: 'pickerSet', //选择器

      setReadOnly: false,
      //线索信息
      clue: {
        clueBase: {
          autoId: 0,
          contactName: '',
          customerName: '',
          position: '',
          clueName: '',
          status: '',
          infoSource: '',
          busInfo: '',
          tel: '',
          weChat: '',
          mail: '',
          toSal: '0',
          statusTxt: '',
          infoSourceTxt: '',
          toSalTxt: '',
          createBy: 0,
          createByTxt: '',
          createTimeTxt: '',
          updateByTxt: '',
          updateTimeTxt: '',
        },
        clueHistoryLog: [],
        clueBackGround: '',
        oldSal:'',
      },
      //下拉弹出
      pop: {
        show: false, //是否显示POP
        operType: 0, //POP类型 根据类型不同显示不同数据 具体类型看上面template
        title: '', //POP标题
        list: [], //POP下拉数据
        location: 'bottom', //POP展示位置
        popHeight: '35%', //高度
        showCom: this.pickerSet,
        confirmTxt: '',
        cancelTxt: '',
      },
      //跟进状态
      clueStatus: {
        data: [], //API数据
        list: [], //下拉数据
      },
      //数据来源
      source: {
        data: [], //API数据
        list: [], //下拉数据
      },
      //销售员
      salseman: {
        data: [], //API数据
        list: [], //下拉数据
      },
    }
  },
  methods: {
    init() {
      if (this.id != 0) {
        this.getClueInof()
      }
    },
    async getClueInof() {
      var res = await clueModel.getClueDetail({
        id: this.id,
      })
      if (res.success) {
        this.clue.clueBase = res.data.clueBaseInfo
        this.clue.clueHistoryLog = res.data.clueBackGroundInfo
        if (this.clue.clueBase.createBy == this.userId) {
          this.setReadOnly = false
        } else {
          this.setReadOnly = true
        }
        this.oldSal=this.clue.clueBase.toSal
      }
    },
    cancel() {
      this.$router.push({ path: '/clue' })
    },
    async submit() {
      if (this.clue.clueBase.clueName == '') {
        this.$toast('请输入线索名称')
      } else if (this.clue.clueBase.contactName == '') {
        this.$toast('请输入联系人姓名')
      } else if (this.clue.clueBase.tel == '') {
        this.$toast('请输入联系人电话')
      } else if (this.clue.clueBase.infoSource == '') {
        this.$toast('请选择信息来源')
      } else if (this.clue.clueBase.status == '') {
        this.$toast('请选择跟进状态')
      } else if (this.clue.clueBackGround == '') {
        this.$toast('请输入线索背景及需求详情记录')
      } else {
        const clueData = {
          ClueBaseInfo: this.clue.clueBase,
          ClueBackGroundInfo: [{ InfoBackground: this.clue.clueBackGround }],
        }

        var res
        var send = false
        if (this.id == 0) {
          res = await clueModel.addClue(clueData, null)
        } else {
          res = await clueModel.updateClue(clueData, null)
        }
        if (res.success) {
          if (this.id == 0 && this.clue.clueBase.toSal != 0) {
            send = true
          }else if(this.id!=0&&this.oldSal!=this.clue.clueBase.toSal){
            send = true
          }
          if (send) {
            var msgRes=await smsModel.sendClueMail(null, {
              salCode: this.clue.clueBase.toSal,
            })
            if (msgRes.success) {
              this.$toast('线索信息提交成功')
            } else {
              this.$toast('客户信息提交成功,邮件发送失败')
            }
          }
          this.$toast('线索信息提交成功')
          this.$router.push({ path: '/clue' })
        } else {
          this.$toast(res.msg)
        }
      }
    },
    showPopup(operType, showCom) {
      this.pop.showCom = showCom
      this.pop.operType = operType
      this.pop.list = []

      if (this.pop.operType == 0) {
        this.pop.title = '跟进状态'
        this.pop.list = this.clueStatus.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 1) {
        this.pop.title = '信息来源'
        this.pop.list = this.source.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      } else if (this.pop.operType == 2) {
        this.pop.title = '销售员'
        this.pop.list = this.salseman.list
        this.pop.confirmTxt = '选择'
        this.pop.cancelTxt = '关闭'
      }
      this.pop.show = true
    },
    hidePopup() {
      this.pop.show = false
    },
    onPopConfirm(value, index) {
      if (this.pop.operType == 0) {
        this.clue.clueBase.status = this.clueStatus.data[index].code
        this.clue.clueBase.statusTxt = this.clueStatus.data[index].displayValue
      } else if (this.pop.operType == 1) {
        this.clue.clueBase.infoSource = this.source.data[index].code
        this.clue.clueBase.infoSourceTxt = this.source.data[index].displayValue
      } else if (this.pop.operType == 2) {
        this.clue.clueBase.toSal = this.salseman.data[index].salesmanCode
        this.clue.clueBase.toSalTxt = this.salseman.data[index].salesmanName
      }
      this.hidePopup()
    },
    async searchSalData() {
      if (this.clue.clueBase.toSalTxt == '') {
        this.$toast('请输入销售员名称')
      } else {
        const res = await commonModel.getSalsByName({
          salName: this.clue.clueBase.toSalTxt,
        })
        if (res.success) {
          if (res.count > 0) {
            this.salseman.data = res.data
            this.salseman.list = []
            this.salseman.data.forEach((item) => {
              this.salseman.list.push(
                item.salesmanName + '(' + item.salesmanCode + ')'
              )
            })
            this.showPopup(2, this.pickerSet)
          } else {
            this.$toast('未找到姓名销售员')
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    changeSal() {
      this.clue.clueBase.toSal = '0'
    },
    async getSource() {
      const res = await globParamModel.getSource({})
      if (res.success) {
        this.source.data = res.data
        this.source.list = []
        this.source.data.forEach((item) => {
          this.source.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },
    async getStatus() {
      const res = await globParamModel.getClueStatus({})
      if (res.success) {
        this.clueStatus.data = res.data
        this.clueStatus.list = []
        this.clueStatus.data.forEach((item) => {
          this.clueStatus.list.push(item.displayValue)
        })
      } else {
        this.$toast(res.msg)
      }
    },

    showheigh() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.submitShow = false
      } else {
        this.submitShow = true
      }
    },
  },
  mounted() {
    this.getSource()
    this.getStatus()
    this.init()
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight
      })()
    }
  },
  computed: {
    ...mapState('userAbout', ['userId']),
    ...mapState('systemAbout', ['approveParam']),
  },
}
</script>
<style scoped>
.btnCenter {
  margin: 0 auto;
  display: block;
  width: 30%;
}
</style>